import React from 'react';

import {
  getConfirmCodePromoConfig,
  getFundingAccountPromoConfig
} from '../../../helpers/promotions';
import Alert from '../Alert';

interface Props {
  promotionId: string;
  ctaType: 'confirmCode' | 'fundingAccount';
  planName?: string;
  currentFee: number;
}

export default function PromotionCta({
  promotionId,
  ctaType,
  planName = 'standard',
  currentFee
}: Props) {
  const { header, subheader } =
    ctaType === 'confirmCode'
      ? getConfirmCodePromoConfig(promotionId)
      : getFundingAccountPromoConfig(promotionId, planName, currentFee);

  return header && subheader ? (
    <Alert
      heading={header}
      message={subheader}
      color={ctaType === 'fundingAccount' ? 'yellow' : 'green'}
      icon={ctaType === 'fundingAccount' ? 'lightbulb' : 'greenCheck'}
    />
  ) : null;
}
